module.exports = __webpack_public_path__ + "static/media/card_01.0c8f4b89.png";